module.exports = __webpack_public_path__ + "img/comp-33.705dda74.png";